import { useMutation, useQuery } from 'react-query';
import { RecruitmentInterviewStatus } from '@api/RecruitmentInterviewStatus';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListRecruitmentInterviewStatus = (
  [page_no, searchText, selectedStatus],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['recruitment-interview-status-list', page_no, searchText, selectedStatus],
    RecruitmentInterviewStatus.listRecruitmentInterviewStatus,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};
// Create
const useAddRecruitmentInterviewStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentInterviewStatus.addRecruitmentInterviewStatus, {
    onSuccess,
    onError
  });
};
// Details
const useViewRecruitmentInterviewStatus = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-interview-status-view', () => RecruitmentInterviewStatus.viewRecruitmentInterviewStatus(id), {
    onSuccess,
    onError
  });
};
// Details
const useShowRecruitmentInterviewStatus = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-interview-status-show', () => RecruitmentInterviewStatus.showRecruitmentInterviewStatus(id), {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentInterviewStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentInterviewStatus.updateRecruitmentInterviewStatus, {
    onSuccess,
    onError
  });
};
// Delete
const useDeleteRecruitmentInterviewStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentInterviewStatus.deleteRecruitmentInterviewStatus, {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentInterviewStatusStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentInterviewStatus.changeStatusRecruitmentInterviewStatus, {
    onSuccess,
    onError
  });
};
// Set Sequence Number
const useGetInterviewMaxSequenceNumber = (onSuccess, onError = onDefaultError) => {
  useQuery(
    'max-sequence-number',
    () => RecruitmentInterviewStatus.getMaxSequenceNumber(),
    {
      onSuccess,
      onError
    }
  );
};
// Sequence Update and Shift By one
const useUpdateSequenceAndShiftInterview = (onSuccess, onError = onDefaultError) => {
  return useMutation(
    (request) => RecruitmentInterviewStatus.updateTaskStatusTypeSequenceAndShift(request),
    {
      onSuccess,
      onError
    }
  );
};
// Get Existing Sequence
const usefetchInterviewExistingSequences = (
  { interviewStatusId = '' }, // accept as object
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['interview-sequence', interviewStatusId], // unique key
    () => RecruitmentInterviewStatus.getExistingSequenceTaskStatusTypes(interviewStatusId),
    {
      onSuccess,
      onError
    }
  );
};
export {
    useListRecruitmentInterviewStatus,
    useAddRecruitmentInterviewStatus,
    useViewRecruitmentInterviewStatus,
    useShowRecruitmentInterviewStatus,
    useUpdateRecruitmentInterviewStatus,
    useDeleteRecruitmentInterviewStatus,
    useUpdateRecruitmentInterviewStatusStatus,
    useUpdateSequenceAndShiftInterview,
    usefetchInterviewExistingSequences,
    useGetInterviewMaxSequenceNumber
};